import type { HelpFile } from '../../types/help'
import { VersionHistoryCardTestIds } from '../../../testids/VersionHistoryCardTestIds'

export const versionHistoryCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [VersionHistoryCardTestIds.versionHistoryCard]:
      'Version history of this restriction rule — every saved revision with author and timestamp.',
    [VersionHistoryCardTestIds.cardTitleVersionHistory]: null,
    [VersionHistoryCardTestIds.versionLoading]: null,
    [VersionHistoryCardTestIds.versionEmpty]:
      'No previous versions exist for this rule yet.',
    [VersionHistoryCardTestIds.versionError]:
      'Could not load the version history. Try again later or check the error log.',
  },
}
